export class TwoFactorDetailsModel {
  constructor({ BackupCodes, ImageUrl, ManualSetupCode }) {
    this.BackupCodes = BackupCodes;
    this.ImageUrl = ImageUrl;
    this.ManualSetupCode = ManualSetupCode;
  }
}

export default TwoFactorDetailsModel;
